<template>
  <div
    class="search-container"
    :class="{ 'no-text-input': selectedField.type === 'select' }"
  >
    <div class="search-field-select">
      <select
        :value="filters.searchField"
        :disabled="disabled"
        data-testid="search-field"
        @change="onSearchFieldChange($event.target.value)"
      >
        <option v-for="field in fields" :key="field.key" :value="field.key">
          {{ field.label }}
        </option>
      </select>

      <select
        v-if="selectedField.type === 'select'"
        :value="filters.searchQuery"
        :disabled="disabled || !selectedField.options.length"
        data-testid="search-select-value"
        @change="onSelectValueChange($event.target.value)"
      >
        <option
          v-for="option in selectedField.options"
          :key="`${selectedField.key}-${option.value}`"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>

    <input
      v-if="selectedField.type !== 'select'"
      :value="filters.searchQuery"
      type="text"
      class="search-input"
      :placeholder="placeholder"
      :disabled="disabled"
      data-testid="search-input"
      @input="onSearchQueryChange($event.target.value)"
      @keyup.enter="onApply"
    />

    <button
      type="button"
      class="search-button"
      :disabled="disabled"
      data-testid="search-button"
      @click="onApply"
    >
      <i class="ion-ios-search" />
    </button>
  </div>
</template>

<script>
const defaultFilters = {
  searchField: '',
  searchQuery: '',
  appliedSearchQuery: '',
};

export default {
  name: 'SearchFilters',
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => ({ ...defaultFilters }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    selectedField() {
      const fallback = {
        key: '',
        type: 'text',
        options: [],
      };

      const field =
        this.fields.find(item => item.key === this.filters.searchField) ||
        this.fields[0] ||
        {};

      return {
        ...fallback,
        ...field,
        options: field.options || [],
      };
    },
  },
  methods: {
    emitFilters(nextFilters) {
      this.$emit('update:filters', {
        ...defaultFilters,
        ...this.filters,
        ...nextFilters,
      });
    },
    onSearchFieldChange(fieldKey) {
      this.emitFilters({
        searchField: fieldKey,
      });
      this.$emit('search-field-change', fieldKey);
    },
    onSearchQueryChange(value) {
      this.emitFilters({
        searchQuery: value,
      });
    },
    onSelectValueChange(value) {
      this.emitFilters({
        searchQuery: value,
      });
      this.onApply();
    },
    onApply() {
      this.$emit('apply');
    },
  },
};
</script>

<style scoped lang="scss">
.search-container {
  display: flex;
  align-items: center;
  width: 600px;
  height: 38px;
  background: #f5f6f7;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e2e2e2;
  margin-bottom: var(--space-medium);
}

.search-field-select {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 8px;
  position: relative;
  flex-shrink: 0;
}

.search-field-select select {
  border: none;
  background: transparent;
  font-size: 13px;
  color: #2d3748;
  cursor: pointer;
  outline: none;
  height: 100%;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 0 18px 0 4px;
  background-image: url("data:image/svg+xml;utf8,<svg fill='%232d3748' height='10' viewBox='0 0 20 20' width='10' xmlns='http://www.w3.org/2000/svg'><path d='M5 7l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 4px center;
  margin-top: 15px;
}

.search-field-select select + select {
  margin-left: 8px;
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  height: 100%;
  margin: 0 6px;
  padding: 0 10px;
  font-size: 13px;
  color: #4a5568;
}

.search-button {
  width: 40px;
  height: 100%;
  background: #1f73d8;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
}

.search-button i {
  font-size: 15px;
}

.search-container.no-text-input {
  width: 420px;
}

.search-container.no-text-input .search-field-select {
  flex: 1;
}

.search-container.no-text-input .search-field-select select {
  width: 100%;
}
</style>
